import React from 'react';
const HomePage = React.lazy(() => import("app/pages/home"));
export const homeRoutes = [
  {
    path: "/",
    element: <HomePage />,
  },
];
